import { render, staticRenderFns } from "./SubmissionHistoryReportResults.vue?vue&type=template&id=651d3e7d&scoped=true&"
import script from "./SubmissionHistoryReportResults.vue?vue&type=script&lang=js&"
export * from "./SubmissionHistoryReportResults.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionHistoryReportResults.vue?vue&type=style&index=0&id=651d3e7d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d3e7d",
  null
  
)

export default component.exports